import {CodeToInputGroupName} from '../codeToInputGroupName';
import farmIcon from '../../../assets/image/inputGroups/farm.svg';
import fertilizerIcon from '../../../assets/image/inputGroups/fertilizer.svg';
import toolsIcon from '../../../assets/image/inputGroups/tools.svg';
import employeeIcon from '../../../assets/image/inputGroups/work.svg';
import machineryIcon from '../../../assets/image/inputGroups/machinery.svg';
import pesticideIcon from '../../../assets/image/inputGroups/pesticide.svg';
import seedIcon from '../../../assets/image/inputGroups/seed.svg';
import labIcon from '../../../assets/image/shop/laboratory.svg';

const ICON_SET = {
  fertilizer: fertilizerIcon,
  pesticide: pesticideIcon,
  seed: seedIcon,
  employee: employeeIcon,
  machinery: machineryIcon,
  tool: toolsIcon,
  farm: farmIcon,
  lab: labIcon,
};

export function getInputGroupIconById({
  selectedInputGroup,
}: {
  selectedInputGroup: string | number | undefined;
}) {
  if (typeof selectedInputGroup === 'undefined') return;
  const formattedSelectedInputGroup = CodeToInputGroupName[
    Number(selectedInputGroup)
  ] as keyof typeof ICON_SET;
  return ICON_SET[formattedSelectedInputGroup];
}
